var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"close-button",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._v("\n    ✕ 閉じる\n")])}
var staticRenderFns = []

export { render, staticRenderFns }